import { useEffect, useState } from "react";
import app from "../components/app";

const statusSample = {
  title:"",
  created:"",
  modified:"",
  status:true,
  color:"#f1f1f1",
  sort:0
}

const saveStatus= function(data, callback) {
  data.data["modified"] = Date.now();
  app.fetchPut(`/statuses/${data.id}`, data.data).then(function(response){
    callback();
  });
}

function Statuses() {
  const [statuses, setStatuses] = useState([]);
  const [status, setStatus] = useState(JSON.parse(JSON.stringify(statusSample)));
  const [index, setIndex] = useState(null);
  

  useEffect(() => {
    app.fetchGet("/statuses").then(function(response){
      //console.log(response)
      const nextStatuses = [];
      for(var key in response) {
        nextStatuses.push({
          id:key,
          data:response[key]
        })
      }
      setStatuses(nextStatuses);
    });
    
  }, []);
  const addStatus = function() {
    if(index !== null) {
      updateStatus();
      return false;
    }
    if(status.title === "") {
      alert("Please enter Status!");
      return false;
    }
    const created = Date.now();
    status["created"] = created;
    status["modified"] = created;
    app.fetchPost("/statuses", status).then(function(response){
      //console.log(response);
      document.querySelector("#title").value = "";
      setStatuses([...statuses, {id:response.name, data:status}])
      setStatus(JSON.parse(JSON.stringify(statusSample)));
    });
  }
  const updateStatus= function() {
    if(status.title === "") {
      alert("Please enter Status!");
      return false;
    }
    status["modified"] = Date.now();
    app.fetchPut(`/statuses/${statuses[index].id}`, status).then(function(response){
      //console.log(response);
      document.querySelector("#title").value = "";
      const nextStatuses = [...statuses];
      nextStatuses[index].data = status;
      setStatuses(nextStatuses);
      setStatus(JSON.parse(JSON.stringify(statusSample)));
      setIndex(null);
    });
  }
  const editStatus = function(index) {
    setIndex(index);
    setStatus(statuses[index].data);
    document.querySelector("#title").value = statuses[index].data.title;
  }
  const onInput = function(event){
    const obj = event.currentTarget;
    
    const nextTask = JSON.parse(JSON.stringify(status));
    nextTask[obj.id] = obj.value;
    
    setStatus(nextTask)
  }
  const onBlur = function(event){
    const obj = event.currentTarget;
    const nextStatuses = [...statuses];
    nextStatuses[obj.getAttribute("data-index")].data[obj.getAttribute("id")] = obj.value;
    saveStatus(nextStatuses[obj.getAttribute("data-index")], function(){
      setStatuses(nextStatuses);
    })
  }
  return <div className="container-fluid p-4 task-list">
    <h1>All Statuses</h1>
    <div className="input-group mb-3 input-group-lg">
  <input type="text" className="form-control" placeholder="Add Status Title" id="title" onInput={onInput}  />
  <button className="btn btn-secondary" type="button" onClick={addStatus}>ADD STATUS</button>
</div>


    <div className="w-100">
   
    <ul className="list-group">
      {
        statuses.map(function(v, i){
          return <li key={v.id} className="list-group-item">
            {v.data.title}
<div className="float-end d-flex">
<input type="number" className="form-control me-1 text-center" id="sort" style={{width:"80px"}} data-index={i} placeholder="Sort" defaultValue={v.data.sort} onBlur={onBlur} />
<input type="color" className="form-control form-control-color  me-1" id="color" style={{width:"80px"}} data-index={i}  defaultValue={v.data.color} onBlur={onBlur} />


            <div className="btn-group">

  <button type="button" className="btn btn-outline-secondary material-icons" onClick={() => editStatus(i)}>edit</button>
  <button type="button" className="btn btn-outline-secondary material-icons" onClick={() => editStatus(i)}>delete</button>
</div>
</div>
          </li>
        })
      }
    </ul>

    
    </div>

  </div>
}

export default Statuses;
